import React, { useEffect, useState } from "react";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { db } from "./firebase";
import {
  collection,
  addDoc,
  doc,
  runTransaction,
  onSnapshot
} from "firebase/firestore";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import logo from "./assets/logo.png";
import Admin from "./Admin";
import Login from "./Login";

/* ✅ COURT CONFIG */
const COURTS = [
  { id: "box1", name: "Box Cricket Court 1", price: { normal: 600, premium: 800 } },
  { id: "box2", name: "Box Cricket Court 2", price: { normal: 600, premium: 800 } },
  { id: "bigbox", name: "Big Box Cricket", price: { normal: 1000, premium: 1200 } },
  { id: "net1", name: "Net Practice", price: { normal: 400, premium: 500 } },
  { id: "net2", name: "Net Practice with Bowling machine", price: { normal: 500, premium: 600 } }
];

const TOTAL_COURTS = 5;

function Home() {
  const [slots, setSlots] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
  new Date().toISOString().split("T")[0]
);
const [showCalendar, setShowCalendar] = useState(false);
  const [phone, setPhone] = useState("");
  const [bgIndex, setBgIndex] = useState(0);
  const [selectedCourt, setSelectedCourt] = useState("");
  const [duration, setDuration] = useState(1);
  const generateDates = (days = 10) => {
  const dates = [];
  for (let i = 0; i < days; i++) {
    const d = new Date();
    d.setDate(d.getDate() + i);
    dates.push(new Date(d));
  }
  return dates;
};

const dateList = generateDates(10);

  // ✅ FIXED loading per slot
  const [loadingSlotId, setLoadingSlotId] = useState(null);

  // ✅ WhatsApp states
  const [showWAButton, setShowWAButton] = useState(false);
  const [waLink, setWaLink] = useState("");

  const navigate = useNavigate();
    const auth = getAuth();
  
const goToAdmin = async () => {
  const auth = getAuth();

  await signOut(auth); // 🔥 force logout

  window.open("/admin", "_blank"); // 🔥 open in new tab
};

  const backgrounds = [
    "https://images.unsplash.com/photo-1593766827228-8737b4534aa6",
    "https://images.unsplash.com/photo-1508098682722-e99c643e7f0b",
    "https://images.unsplash.com/photo-1574629810360-7efbbe195018",
    "https://images.unsplash.com/photo-1517649763962-0c623066013b"
  ];

  const getHour = (time) => {
  return parseInt(time.split(":")[0]);
};

  const sortSlots = (slots) => {
    return slots.sort((a, b) => {
  const t1 = getHour(a.time);
  const t2 = getHour(b.time);
  return t1 - t2;
});
  };

  useEffect(() => {
  const interval = setInterval(() => {
    setBgIndex((prev) => (prev + 1) % backgrounds.length);
  }, 4000);

  return () => clearInterval(interval);
}, [backgrounds.length]);

  useEffect(() => {
  const unsubscribe = onSnapshot(collection(db, "slots"), (snapshot) => {
    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    const sorted = sortSlots(data).sort((a, b) => {
      const aPremium = isPremiumSlot(a.time);
      const bPremium = isPremiumSlot(b.time);

      return bPremium - aPremium;
    });

    setSlots(sorted);
  });

  // ✅ CORRECT PLACE
  return () => unsubscribe();

}, [selectedDate]);

  const isPremiumSlot = (time) => {
  const hour = getHour(time);

  return (
    (hour >= 5 && hour < 10) ||
    (hour >= 17 && hour < 24)
  );
};
const formatTime = (time) => {
  const [start, end] = time.split("-");

  const format = (t) => {
    let h = parseInt(t);
    const suffix = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h}${suffix}`;
  };

  return `${format(start)} - ${format(end)}`;
};

  const generateBookingId = () => {
    return "RPA" + Date.now().toString().slice(-6);
  };

  const getPrice = (time) => {
    const court = COURTS.find(c => c.id === selectedCourt);
    if (!court) return 0;
    return court.price[isPremiumSlot(time) ? "premium" : "normal"];
  };

  const today = new Date().toISOString().split("T")[0];


  const now = new Date();

const filteredSlots = slots.filter((s) => {
  if (s.date !== selectedDate) return false;

  const slotHour = parseInt(s.time.split(":")[0]);

  const slotDateTime = new Date(s.date);
  slotDateTime.setHours(slotHour, 0, 0, 0);

  return slotDateTime > now;
});

  // ✅ FINAL BOOKING FUNCTION
  const handleBooking = (slot) => {
    if (!selectedCourt) return alert("Please select a court");
    if (!/^[0-9]{10}$/.test(phone)) return alert("Enter valid 10-digit phone number");
const now = new Date();

const slotHour = parseInt(slot.time.split(":")[0]);
const slotDateTime = new Date(slot.date);
slotDateTime.setHours(slotHour, 0, 0, 0);

if (slotDateTime <= now) {
  return alert("Cannot book past time slot");
}
    const startIndex = filteredSlots.findIndex(s => s.id === slot.id);
    const selectedSlots = filteredSlots.slice(startIndex, startIndex + duration);

    if (selectedSlots.length !== duration) {
  return alert(`Only ${selectedSlots.length} continuous slots available`);
}

    for (let s of selectedSlots) {
      const bookedCourts = s.bookedCourts || [];
      if (bookedCourts.includes(selectedCourt)) {
        return alert("One of the selected slots is already booked");
      }
    }

    let totalAmount = 0;

selectedSlots.forEach(s => {
  totalAmount += getPrice(s.time);
});

    setLoadingSlotId(slot.id);
if (!window.confirm(`You are booking ${duration} hour(s)\nTotal: ₹${totalAmount}`)) {
  return;
}
    new window.Razorpay({
      key: "rzp_test_ScGo79CIlAK5CC",
      amount: totalAmount * 100,
      currency: "INR",
      name: "Rainbow Recreation Play Arena",
      handler: async (response) => {
        try {
          const bookingId = generateBookingId();
          const court = COURTS.find(c => c.id === selectedCourt);

          await runTransaction(db, async (transaction) => {

  // STEP 1: READ ALL DOCUMENTS FIRST
  const slotDocs = [];

  for (let s of selectedSlots) {
    const ref = doc(db, "slots", s.id);
    const snap = await transaction.get(ref);
    slotDocs.push({ ref, snap });
  }

  // STEP 2: VALIDATE (NO COURT SHOULD BE ALREADY BOOKED)
  for (let { snap } of slotDocs) {
  const data = snap.data() || {};
  const bookedCourts = data.bookedCourts || [];

  // 🟥 Bigbox dominates everything
  if (
    bookedCourts.includes("bigbox") ||
    (selectedCourt === "bigbox" && bookedCourts.length > 0)
  ) {
    throw new Error("Conflict with Big Box booking");
  }

  // 🟧 Box2 vs Nets conflict (both directions)
  if (
    (selectedCourt === "box2" &&
      (bookedCourts.includes("net1") || bookedCourts.includes("net2"))) ||
    ((selectedCourt === "net1" || selectedCourt === "net2") &&
      bookedCourts.includes("box2"))
  ) {
    throw new Error("Conflict between Box2 and Nets");
  }

  // ❌ Same court already booked
  if (bookedCourts.includes(selectedCourt)) {
    throw new Error("Court already booked");
  }
}

  // STEP 3: UPDATE ALL DOCUMENTS
  for (let { ref, snap } of slotDocs) {
    const data = snap.data() || {};
    const bookedCourts = data.bookedCourts || [];

    const updatedCourts = [...bookedCourts, selectedCourt];

    transaction.update(ref, {
      bookedCourts: updatedCourts,
      status: updatedCourts.length >= TOTAL_COURTS ? "booked" : "available"
    });
  }
});

          await addDoc(collection(db, "bookings"), {
            bookingId,
            slotIds: selectedSlots.map(s => s.id),
            date: slot.date,
            duration,
            amount: totalAmount,
            phone,
            paymentId: response.razorpay_payment_id,
            courtId: selectedCourt,
            courtName: court?.name
          });

          const type = isPremiumSlot(slot.time) ? "⭐ Premium Slot" : "Normal Slot";
const startTime = selectedSlots[0].time.split("-")[0];
const endTime = selectedSlots[selectedSlots.length - 1].time.split("-")[1];
          const message = `🌈 Rainbow Recreation Play Arena

✅ Booking Confirmed

🆔 Booking ID: ${bookingId}
🏟 Court: ${court?.name}
📅 Date: ${slot.date}
⏰ Time: ${startTime} to ${endTime}
⏳ Duration: ${duration} Hour(s)
🎟 Slot Type: ${type}
💰 Amount: ₹${totalAmount}

See you on the ground! 🔥`;

          const link = `https://wa.me/91${phone}?text=${encodeURIComponent(message)}`;

          // ✅ FIXED WhatsApp behavior
          setShowWAButton(false);
          setWaLink("");

          window.open(link, "_blank");

          setTimeout(() => {
            setWaLink(link);
            setShowWAButton(true);
          }, 500);

          alert(`Booking Confirmed! ID: ${bookingId}`);

        } catch (err) {
  console.error("FULL ERROR:", err);
  alert("Booking failed: " + err.message);
}finally {
          setLoadingSlotId(null);
        }
      },
    }).open();
  };

  const openWhatsApp = () => {
    if (waLink) window.open(waLink, "_blank");
  };

  return (
    <div style={{ minHeight: "100vh", color: "white", position: "relative" }}>

      {/* Background */}
      <div style={{
        position: "fixed",
        width: "100%",
        height: "100%",
        backgroundImage: `url(${backgrounds[bgIndex]})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        transition: "1s",
        zIndex: -2,
      }} />

      <div style={{
        position: "fixed",
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.75)",
        zIndex: -1,
      }} />

      <div style={{ padding: 20, paddingBottom: 90 }}>

  {/* ✅ ADD THIS LOGO BANNER HERE */}
 <div style={{
  width: "100%",
  textAlign: "center",
  marginBottom: 10
}}>
  <img 
  src={logo}
  alt="Logo"
  style={{
    width: "300px",
    maxWidth: "60%",
    height: "auto",
    marginBottom: 8
  }}
/>

  {/* ✅ ADD H2 HERE (below logo) */}
  <h2 style={{
    margin: 0,
    fontSize: 20,
    fontWeight: "700",
    letterSpacing: "0.5px"
  }}>
    🏏 Book Your Cricket Slot
  </h2>

</div>

        <div style={{ 
  textAlign: "center", 
  marginBottom: 15,
  marginTop: 10   // ✅ pushes UI down cleanly
}}>
          <select onChange={(e) => setSelectedCourt(e.target.value)}
            style={{ padding: 10, borderRadius: 20 }}>
            <option value="">Select Court</option>
            {COURTS.map(c => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>

        <div style={{ textAlign: "center", marginBottom: 15 }}>
          <select
            value={duration}
            onChange={(e) => setDuration(Number(e.target.value))}
            style={{ padding: 10, borderRadius: 20 }}
          >
            <option value={1}>1 Hour</option>
            <option value={2}>2 Hours</option>
            <option value={3}>3 Hours</option>
          </select>
        </div>

        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <input
            placeholder="Enter WhatsApp Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            style={{
              padding: 12,
              borderRadius: 25,
              width: "90%",
              maxWidth: 320,
              textAlign: "center",
              border: "none",
            }}
          />
        </div>

        {showWAButton && (
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <button
              onClick={openWhatsApp}
              style={{
                padding: "12px 20px",
                borderRadius: 25,
                background: "#25D366",
                color: "white",
                border: "none",
                fontSize: 16
              }}
            >
              📲 Send WhatsApp Confirmation
            </button>
          </div>
        )}

        <div style={{ display: "flex", overflowX: "auto", gap: 10, marginBottom: 10 }}>
  {dateList.map((dateObj, i) => {
    const formatted = dateObj.toISOString().split("T")[0];
    const isSelected = selectedDate === formatted;

    return (
      <div
        key={i}
        onClick={() => setSelectedDate(formatted)}
        style={{
          minWidth: 80,
          padding: 10,
          borderRadius: 12,
          textAlign: "center",
          cursor: "pointer",
          background: isSelected
            ? "linear-gradient(90deg,#22c55e,#4ade80)"
            : "rgba(255,255,255,0.1)",
          color: "white",
          transition: "0.3s"
        }}
      >
        <div style={{ fontSize: 12 }}>
          {i === 0
            ? "Today"
            : i === 1
            ? "Tomorrow"
            : dateObj.toLocaleDateString("en-US", { weekday: "short" })}
        </div>
        <div style={{ fontWeight: "bold" }}>{dateObj.getDate()}</div>
      </div>
    );
  })}
</div>
<div style={{ textAlign: "center", marginBottom: 15 }}>
  <button
    onClick={() => setShowCalendar(true)}
    style={{
      padding: "8px 16px",
      borderRadius: 20,
      border: "none",
      background: "#2563eb",
      color: "white",
      cursor: "pointer"
    }}
  >
    View All Dates 📅
  </button>
</div>
{/* ✅ STEP 8: CALENDAR MODAL */}
{showCalendar && (
  <div style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.8)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999
  }}>
    <div style={{
      background: "white",
      padding: 20,
      borderRadius: 12
    }}>
      <DatePicker
        selected={new Date(selectedDate)}
        onChange={(date) => {
          const formatted = date.toISOString().split("T")[0];
          setSelectedDate(formatted);
          setShowCalendar(false);
        }}
        inline
        minDate={new Date()}
      />

      <div style={{ textAlign: "center", marginTop: 10 }}>
        <button onClick={() => setShowCalendar(false)}>
          Close
        </button>
      </div>
    </div>
  </div>
)}
<div style={{
  textAlign: "center",
  marginTop: 20,
  marginBottom: 10,
  fontWeight: "bold",
  color: "#facc15"
}}>
  🔥 Premium Slots (5AM–10AM & 5PM–12AM) have higher pricing
</div>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))",
          gap: 12,
          marginTop: 25,
        }}>
          {filteredSlots.map((slot) => {
  const bookedCourts = slot.bookedCourts || [];
  let isBlocked = false;

// 🟥 Bigbox blocks everything
if (bookedCourts.includes("bigbox")) {
  isBlocked = true;
}

// 🟨 Any booking blocks bigbox
if (selectedCourt === "bigbox" && bookedCourts.length > 0) {
  isBlocked = true;
}

// 🟧 Box2 blocks nets
if (
  (selectedCourt === "net1" || selectedCourt === "net2") &&
  bookedCourts.includes("box2")
) {
  isBlocked = true;
}

// 🟧 Nets block box2
if (
  selectedCourt === "box2" &&
  (bookedCourts.includes("net1") || bookedCourts.includes("net2"))
) {
  isBlocked = true;
}

// ✅ Final state
const isBooked = bookedCourts.includes(selectedCourt) || isBlocked;
  let allowedCourts = ["box1", "box2", "net1", "net2", "bigbox"];

// 🟥 Bigbox booked → nothing allowed
if (bookedCourts.includes("bigbox")) {
  allowedCourts = [];
}

// 🟨 Any booking blocks bigbox
if (bookedCourts.length > 0) {
  allowedCourts = allowedCourts.filter(c => c !== "bigbox");
}

// 🟧 Box2 blocks nets
if (bookedCourts.includes("box2")) {
  allowedCourts = allowedCourts.filter(
    c => c !== "net1" && c !== "net2"
  );
}

// 🟧 Nets block box2
if (bookedCourts.includes("net1") || bookedCourts.includes("net2")) {
  allowedCourts = allowedCourts.filter(c => c !== "box2");
}

// ❌ remove already booked courts
allowedCourts = allowedCourts.filter(c => !bookedCourts.includes(c));

const remaining = allowedCourts.length;

  // ✅ ONLY ONE CALL HERE
  const isPremium = isPremiumSlot(slot.time);

  const price = selectedCourt ? getPrice(slot.time) : 0;

  return (
    <div
      key={slot.id}
      style={{
        background: isPremium
          ? "linear-gradient(135deg,#facc15,#f59e0b)"
          : "rgba(255,255,255,0.08)",
        padding: 12,
        borderRadius: 12,
        color: isPremium ? "#000" : "#fff",
        boxShadow: isPremium
          ? "0 0 15px rgba(250,204,21,0.6)"
          : "none",
        border: isPremium ? "2px solid gold" : "1px solid #444"
      }}
    >
      <b>{formatTime(slot.time)}</b>

      {isPremium && (
        <div style={{
          fontSize: 12,
          fontWeight: "bold",
          marginTop: 4
        }}>
          🔥 Premium Slot
        </div>
      )}

      <div style={{ marginTop: 5 }}>₹{price}</div>

      <div style={{ marginTop: 5 }}>
        {isBooked ? "BOOKED" : "AVAILABLE"}
      </div>

      <div style={{ fontSize: 12 }}>
        {remaining > 0 ? `${remaining} courts left` : "Fully Booked"}
      </div>

      <button
        disabled={!selectedCourt || isBooked || loadingSlotId === slot.id}
        onClick={() => handleBooking(slot)}
        style={{
          marginTop: 8,
          width: "100%",
          background: isPremium ? "#000" : "#16a34a",
          color: "white",
          border: "none",
          padding: "8px",
          borderRadius: "8px",
          cursor: "pointer"
        }}
      >
        {loadingSlotId === slot.id ? "Processing..." : "Book Now"}
      </button>
    </div>
  );
})}
        </div>
      </div>

      <div style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        background: "rgba(0,0,0,0.9)",
        display: "flex",
        justifyContent: "space-around",
        padding: 12,
      }}>
        <button onClick={() => navigate("/")}>🏠 Home</button>
        <button onClick={goToAdmin}>Admin Login</button>
      </div>
    </div>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // wait until Firebase loads user
  if (loading) return <div>Loading...</div>;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route
          path="/admin"
          element={user ? <Admin /> : <Login />}
        />

        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;